module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sw-ts-root"
  }, [_c('v-autocomplete', {
    class: _vm.compact ? 'sw-ts-autocomplete sw-ts-compact' : 'sw-ts-autocomplete sw-ts-outlined',
    attrs: {
      "value": _vm.normalizedValue,
      "items": _vm.selectItems,
      "item-value": "value",
      "item-text": "text",
      "loading": _vm.loading,
      "disabled": _vm.disabled,
      "label": _vm.compact ? '' : _vm.fieldLabel,
      "placeholder": _vm.fieldLabel,
      "dense": _vm.compact,
      "hide-details": "",
      "hide-no-data": false,
      "menu-props": {
        contentClass: 'sw-ts-menu'
      },
      "solo": _vm.compact,
      "flat": _vm.compact,
      "outlined": !_vm.compact,
      "clearable": ""
    },
    on: {
      "input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "append-item",
      fn: function() {
        return [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
          staticClass: "sw-ts-add-item",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openCreateDialog.apply(null, arguments)
            }
          }
        }, [_c('v-list-item-icon', {
          staticClass: "mr-2"
        }, [_c('v-icon', {
          attrs: {
            "color": "#0091d5",
            "size": "22"
          }
        }, [_vm._v("mdi-account-plus")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "sw-ts-add-title"
        }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.addTechnician')) + "\n          ")])], 1)], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('survey-work-new-technician-dialog', {
    on: {
      "created": _vm.onTechnicianCreated
    },
    model: {
      value: (_vm.createDialog),
      callback: function($$v) {
        _vm.createDialog = $$v
      },
      expression: "createDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273791ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/SurveyWorkTechnicianSelect.vue
// module id = 1693
// module chunks = 0